module.exports = __webpack_public_path__ + "static/media/jquery.cf2cb70f.svg";